export default function NotificationSettings() {
    return null;
}
